export default __webpack_public_path__ + "static/media/magazine.26d986a6.gif";